<template>
  <div class="integracoes-base">
    <PTabs
      :items="tabs"
      v-model="tabSelecionada"
      @update:modelValue="handleTabClick"
    />

    <router-view />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { EIntegracoes } from "./router";
import { F360Product } from "@/core/@types/types";
import useF360Router from "@/core/router/useF360Router";
import { PTabs } from "@f360-dev/f360-prisma";

type PTabsItem = {
  name: string;
  label: string;
};

const router = useRouter();

const tabSelecionada = ref<string>(EIntegracoes.Painel);

const { handlePrefixName } = useF360Router();

const tabs: PTabsItem[] = [
  {
    name: EIntegracoes.Painel,
    label: "Integrações"
  }
];

const handleTabClick = (tab: string) => {
  router.push({
    name: handlePrefixName(F360Product.Integracoes, tab)
  });
};
</script>

<style lang="scss" scoped>
.integracoes-base {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
}
</style>
